module.exports = __webpack_public_path__ + "static/media/monteagudo.d366cd2c.jpeg";